import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { getApiHeader } from "utlis/commonfunctions";
import axios from "axios";
import { Backdrop, CircularProgress } from "@mui/material";
import PageLayout from "examples/LayoutContainers/PageLayout";
import swal from "sweetalert";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import styled from "@emotion/styled";
import { useLocation } from 'react-router-dom';
import "../../../layouts/Features/TelsimStockRequest/TelsimStock.css"

const SERVER_URL = process.env.REACT_APP_API_URL;

const OnHoldQuantityUpdate = () => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    products:[]
  });
  const [retailer_id, setRetailerId] = useState(null);
  const location = useLocation();

  useEffect(() => {
    const searchParams = location.pathname.split("/");
    const length = location.pathname.split("/").length;
    const encodedRetailerId= searchParams[length-1];
    
    const decodedRetailerId = atob(encodedRetailerId);
   
    setRetailerId(decodedRetailerId);
    handleFetchProducts();
  }, []);


  const handleFetchProducts = async (e) => {
    setLoading(true);
    try {
      const headers = await getApiHeader();
      const productResponse = await axios.post(
        `${SERVER_URL}product_category`,
        { },
        { headers }
      );
      // console.log("productResponse", productResponse);
      if (productResponse?.data?.status === 200) {
        setLoading(false);
        const productData = productResponse?.data?.data?.products.map((data) => ({
          product_name: data.offerName,
          product_id: data.product_id,
          category_id: data.rtap_product_category_id,
          stock_quantity:""
        }))
        setFormData((prevFormData) => ({
          ...prevFormData,
          products: productData,
        })
        )
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error fetching products:", error);
    }
  };



  const handleSubmit = async (event) => {
    event.preventDefault();
    const filteredProducts = formData.products.filter(
      (product) => product.stock_quantity && product.stock_quantity !== "0"
    );
        // Check if filteredFormData is empty
        if (Object.keys(filteredProducts).length === 0) {
          toast.error("Please fill in at least one input field");
          return;
        }

    try {
      const payload = {
        retailer_id: retailer_id,
       products:filteredProducts
      };

      setLoading(true);
      const headers = await getApiHeader();
      const response = await axios.post(`${SERVER_URL}onholdstock_update `, payload, {
        headers: headers,
      });
      // console.log("handleSubmit", response);
      if (response.status === 200) {
        setLoading(false);
        swal({
          title: "Success",
          text: response.data.message,
          icon: "success",
          button: "Close",
        }).then(() => {
          setFormData({
            products: []
          });
          handleFetchProducts()
        });
      }
    } catch (error) {
      setLoading(false);
      console.log("error", error);
      const message = error?.response?.data?.message;
      swal({
        title: "error",
        text: message,
        icon: "error",
        button: "Close",
      });
    }
  };

  const StyledToastContainer = styled(ToastContainer)`
    /* Your styles here */
    .Toastify__toast {
      border-radius: 4px;
      background-color: white;
      height: auto; /* Add a semicolon to separate properties */
      color: black; /* Use "color" instead of "fontColor" */
    }
    .Toastify__toast--success {
    }

    .Toastify__toast--error {
    }
  `;



  const handleChangeSelect =(event,product_id)=>{
    const { value } = event.target;
    const { products } = formData;
    const newProducts = products.map((product) => {
      if (product.product_id === product_id) {
        return {
          ...product,
          stock_quantity: value,
        };
      }
      return product;
    });
    setFormData((prevFormData) => ({
      ...prevFormData,
      products: newProducts
    }));
  }
  
  return (
    <>
      <PageLayout background="white">
        {loading && (
          <Backdrop
            open={true}
            style={{
              color: "#fff",
              zIndex: 9999,
            }}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
        )}
        <StyledToastContainer hideProgressBar={false} position="top-right" autoClose={1000} />

        <div style={{ padding: "10px" }} className="contactus-wrapper">
          <div
            className="container py-5"
            style={{
              borderRadius: "10px",
              borderColor: "#C11D6C",
              borderWidth: "2px",
              borderStyle: "solid",
              marginTop: "50px",
            }}
          >
            <h2 className="text-center mb-4" style={{ color: "#C11D6C" }}>
              On Hold Stock Update
            </h2>
            <div className="row">
              {/* Contact Form Section */}
              <div className="d-flex justify-content-center">
                <form
                  style={{
                    width: "80%",
                    // maxWidth: "650px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                  onSubmit={handleSubmit}
                >

                  {formData?.products && formData?.products.length > 0 && (
                    <div className="container" style={{ marginTop: "10px" }}>
                      <div className="row">
                        <div className="col-md-12">
                          <div className="table-responsive stock-form-product-table">
                            <table id="mytable" className="table table-bordred">
                              <thead>
                                <tr>
                                  <th>Sl No</th>
                                  <th>Offer Name</th>
                                  <th>Quantity</th>
                                </tr>
                              </thead>
                              <tbody>
                                {formData?.products.map((data, index) => (
                                  <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td className="stock-form-product-name">{data.product_name || "N/A"}</td>
                                    <td className="stock-form-product-quantity">
                                      <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Quantity"
                                        value={data.stock_quantity}
                                        onChange={(e) => handleChangeSelect(e, data.product_id)}
                                      />
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>

                        </div>
                      </div>
                    </div>
                  )}

                  <div className="text-center w-100 mt-4">
                    <button type="submit" className="recharge_button">
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </PageLayout>
    </>
  );
};

export default OnHoldQuantityUpdate;
